module.exports = __webpack_public_path__ + "img/bg.b37b3ffd.png";